export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  /** @deprecated DB value removed by migration 29; still normalized on read */
  PLATFORM_ADMIN: 'platform_admin',
  ACCOUNT_MANAGER: 'account_manager',
  CLIENT: 'client',
  INFLUENCER: 'influencer',
}

export const LEGACY_ROLES = {
  ADMIN: 'admin',
}

/** Roles that may appear on global operator rows (legacy admin before migration 30). */
export const SUPER_ADMIN_STORED_ROLES = [
  USER_ROLES.SUPER_ADMIN,
  LEGACY_ROLES.ADMIN,
]

export function normalizeRole(role, tenantId = undefined) {
  const value = String(role || '').trim().toLowerCase()
  if (!value) return ''
  if (value === LEGACY_ROLES.ADMIN) {
    if (tenantId === null) return USER_ROLES.SUPER_ADMIN
    if (tenantId != null) return USER_ROLES.ACCOUNT_MANAGER
    return USER_ROLES.ACCOUNT_MANAGER
  }
  if (value === USER_ROLES.PLATFORM_ADMIN && tenantId == null) {
    return USER_ROLES.SUPER_ADMIN
  }
  return value
}

export function toLegacyRole(role, tenantId = undefined) {
  const normalized = normalizeRole(role, tenantId)
  if (
    normalized === USER_ROLES.SUPER_ADMIN
    || normalized === USER_ROLES.PLATFORM_ADMIN
    || normalized === USER_ROLES.ACCOUNT_MANAGER
  ) {
    return LEGACY_ROLES.ADMIN
  }
  return normalized
}

/**
 * Global platform operator: canonical super_admin with no tenant.
 * Legacy platform_admin / admin + null tenant normalize to super_admin on read.
 */
export function isSuperAdminRole(role, tenantId = null) {
  if (tenantId != null) return false
  return normalizeRole(role, tenantId) === USER_ROLES.SUPER_ADMIN
}

/** @deprecated Use isSuperAdminRole */
export function isPlatformAdminRole(role, tenantId = null) {
  return isSuperAdminRole(role, tenantId)
}

export function isAccountManagerRole(role, tenantId = undefined) {
  return normalizeRole(role, tenantId) === USER_ROLES.ACCOUNT_MANAGER
}

export function isClientRole(role) {
  return normalizeRole(role) === USER_ROLES.CLIENT
}

export function isInfluencerRole(role) {
  return normalizeRole(role) === USER_ROLES.INFLUENCER
}

export function isTenantStaffRole(userRole, tenantId) {
  return isAccountManagerRole(userRole, tenantId) || isClientRole(userRole)
}

export function normalizeAllowedRoles(allowedRoles = []) {
  return allowedRoles.flatMap((role) => {
    const value = String(role || '').trim().toLowerCase()
    if (value === LEGACY_ROLES.ADMIN) {
      return [USER_ROLES.ACCOUNT_MANAGER, LEGACY_ROLES.ADMIN]
    }
    if (value === USER_ROLES.PLATFORM_ADMIN || value === USER_ROLES.SUPER_ADMIN) {
      return [USER_ROLES.SUPER_ADMIN, USER_ROLES.PLATFORM_ADMIN, LEGACY_ROLES.ADMIN]
    }
    return [value]
  })
}

export function roleHasAccess(userRole, allowedRoles = []) {
  const normalizedUser = normalizeRole(userRole)
  const normalizedAllowed = normalizeAllowedRoles(allowedRoles)
  if (normalizedAllowed.includes(normalizedUser)) return true
  const legacyUser = toLegacyRole(normalizedUser)
  return normalizedAllowed.includes(legacyUser)
}
